import { combineReducers } from "redux";
import loader from "redux/reducers/loader"
import auth  from "redux/reducers/auth";
import registerUser from "redux/reducers/registerUser";
import otpVerification from "redux/reducers/otpVerification";
import forgotPassword from "redux/reducers/forgotPassword";
import changePassword from "redux/reducers/changePassword";
import localStorage from "redux/reducers/localStorage";
import requestOrders from "redux/reducers/requestOrders";
import dashboard from "redux/reducers/dashboard";
import invoice from "./invoice";
import invoiceDownload from "./invoiceDownload";
import countrySelection from './countrySelection';

export default combineReducers({
  loader,
  auth,
  changePassword,
  forgotPassword,
  registerUser,
  otpVerification,
  localStorage,
  requestOrders,
  dashboard,
  invoice,
  invoiceDownload,
  countrySelection
})